import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import clsx from 'clsx';
import capitalize from "../../helpers/capitalize";
import { ChevronLeft, ChevronRight } from "../../icons";
import React, { useState } from 'react';
import { SidebarAlignmentType } from "../../types/Sidebar";
import { createStyles } from "./styles";

var Sidebar = function Sidebar(props) {var _context;
  var _useState = useState(true),_useState2 = _slicedToArray(_useState, 2),opened = _useState2[0],setOpened = _useState2[1];

  function handleCloseClick() {
    setOpened(!opened);
  }

  var _props$alignment =




    props.alignment,alignment = _props$alignment === void 0 ? SidebarAlignmentType.LEFT : _props$alignment,children = props.children,className = props.className,_props$wrapperClassNa = props.wrapperClassName,wrapperClassName = _props$wrapperClassNa === void 0 ? '' : _props$wrapperClassNa;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("section", {
      className: clsx(
      classes.sidebar,
      opened ? classes.sidebarOpened : classes.sidebarClosed,
      classes["sidebar".concat(capitalize(alignment))],
      wrapperClassName) }, /*#__PURE__*/


    React.createElement("div", {
      className: clsx(
      classes.sidebarContent,
      opened ? classes.sidebarContentVisible : classes.sidebarContentHidden,
      className) },


    children), /*#__PURE__*/


    React.createElement("button", {
      type: "button",
      onClick: handleCloseClick,
      className: clsx(
      classes.closeButton,
      classes[_concatInstanceProperty(_context = "sidebar".concat(capitalize(alignment), "CloseButton")).call(_context, opened ? 'Opened' : 'Closed')]) },


    alignment === SidebarAlignmentType.LEFT ? /*#__PURE__*/React.createElement(ChevronLeft, null) : /*#__PURE__*/React.createElement(ChevronRight, null))));



};

export default Sidebar;
//# sourceMappingURL=index.js.map